import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import ImageGrid from "../../components/image-grid/ImageGrid";
import { getAllFiles, downloadFileBlob } from "../../state/actions/FileDownloadActions";
import styles from "./ContentPicker.module.scss"
import { Loading } from "../../components/loading/Loading";
import Search from "../../components/search/Search";
import SimpleList from "../../components/simple-list/SimpleList";
import { withTranslation } from "react-i18next";

class ContentPicker extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            searchedData: [],
            originalData: []
        }

        this.retrieveData = this.retrieveData.bind(this);
    }

    componentDidMount() {
        this.retrieveData();
    }

    render() {
        return (
            <div style={{height: "calc(100% - 102px)"}}>
                <Search
                    loading={this.state.loading}
                    searchField={"value"}
                    secondaryFields={["id"]}
                    returnSearchMatches={data => {
                        this.setState({ searchedData: data });
                    }}
                    data={this.state.originalData}
                    searchTitle={this.props.t('targeting-content.search')}
                />
                {
                    this.state.loading ?
                        <Loading /> :
                        <SimpleList
                            emptyPlaceholder={this.props.t('content.no-content-to-assign')}
                            handleSelection={this.props.handleSelection}
                            data={this.state.searchedData}
                            currentSelection={this.props.currentSelection}
                        />
                }
            </div>
        );
    }

    retrieveData() {
        const selected = this.props.selected ? this.props.selected : [];
        this.setState({ loading: true })

        this.props.getAllFiles(() => {
            const fileValues = Object.values(this.props.files);
            const data = []

            fileValues.forEach(value => {
                if (!selected.includes(value.id)) {
                    data.push({
                        id: value.id,
                        value: value.DisplayName
                    });
                }
            });

            this.setState({
                loading: false,
                searchedData: data,
                originalData: data
            })
        });
    }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { files } = state.FileDownloadReducer;
    return { files };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAllFiles,
            downloadFileBlob
        },
        dispatch
    );

const hoc = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withTranslation()(ContentPicker))
);

// EXPORT COMPONENT

export { hoc as ContentPicker };

